import { UIHeading5, UIText3 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import * as style from './style.css';
import { IBuilderStats } from '../../types/newbuilding/builder';

export interface IPremiumBuilderLayoutProps {
  logo: React.ReactElement;
  label?: React.ReactElement | null;
  stats?: IBuilderStats;
  yearOfFoundation?: number;
}

export const PremiumBuilderLayout: React.FC<IPremiumBuilderLayoutProps> = ({
  logo,
  label,
  stats,
  yearOfFoundation,
}) => {
  const isStatsAvailable = !!stats?.done || !!stats?.inProgress;
  const isOnlyDoneStats = !stats?.inProgress && !yearOfFoundation;
  const isOnlyProgressStats = !stats?.done && !yearOfFoundation;

  return (
    <>
      <div className={style['background']} />
      {logo}
      {label && label}

      <div className={style['wrapper']} data-testid="PremiumBuilderLayout">
        {yearOfFoundation && (
          <div className={clsx(style['title'], !isStatsAvailable && style['full-width'])}>
            <UIText3 color="gray60_100">Год&nbsp;основания</UIText3>
            <UIHeading5 color="text-primary-default">{yearOfFoundation}</UIHeading5>
          </div>
        )}

        {stats?.done?.housesText && (
          <a
            className={clsx(style['title'], isOnlyDoneStats && style['full-width'])}
            href={stats.done?.qs}
            target="blank"
            rel="noreferrer"
          >
            <UIText3 color="gray60_100">Сдано</UIText3>
            <UIHeading5 color="text-primary-default">
              {stats.done.housesCount} {stats.done.housesText.split(' ')[0]} {stats.done.newbuildingText}
            </UIHeading5>
          </a>
        )}

        {stats?.inProgress?.housesText && (
          <a
            className={clsx(style['title'], isOnlyProgressStats && style['full-width'])}
            href={stats.inProgress?.qs}
            target="blank"
            rel="noreferrer"
          >
            <UIText3 color="gray60_100">Строится</UIText3>
            <UIHeading5 color="text-primary-default">
              {stats.inProgress.housesCount} {stats.inProgress.housesText.split(' ')[0]}{' '}
              {stats.inProgress.newbuildingText}
            </UIHeading5>
          </a>
        )}
      </div>
    </>
  );
};
